import * as React from 'react';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { IntlProvider, load, LocalizationProvider } from '@progress/kendo-react-intl';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import caGregorian from 'cldr-dates-full/main/pt/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/pt/dateFields.json';
import brNumbers from 'cldr-numbers-full/main/br/numbers.json';
import brCurrency from 'cldr-numbers-full/main/br/currencies.json';

load(brNumbers, brCurrency, likelySubtags, caGregorian, dateFields);

const NumberCell = (props) => {
  const { ariaColumnIndex, columnIndex, dataItem, field, render } = props;
  const isInEdit = field === dataItem.inEdit;
  const value = field && dataItem[field] ? dataItem[field] : null;
  const onChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value
      });
    }
  };
  const numberString = value ? value.toLocaleString(undefined, { minimumFractionDigits: 2 }) : '';
  const defaultRendering = (
    <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
      {isInEdit ? (
        <LocalizationProvider language="pt">
          <IntlProvider locale="pt">
            <div>
              <NumericTextBox name={field} value={value} format="n2" onChange={onChange} />
            </div>
          </IntlProvider>
        </LocalizationProvider>
      ) : (
        numberString
      )}
    </td>
  );
  return render?.call(undefined, defaultRendering, props);
};

export default NumberCell;
